import { EmptyCoroutineContext_instancegbhtm9svfl3r as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BufferOverflow_SUSPEND_getInstanceob833ibjouyy as BufferOverflow_SUSPEND_getInstance } from './BufferOverflow.mjs';
import { CoroutineStart_DEFAULT_getInstance35ogjf7uz6hf2 as CoroutineStart_DEFAULT_getInstance } from '../CoroutineStart.mjs';
import {
  Channel3r72atmcithql as Channel,
  SendChannel38sllbxw662ws as SendChannel,
} from './Channel.mjs';
import { newCoroutineContext2tdpc8c02iv5t as newCoroutineContext } from '../CoroutineContext.mjs';
import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ChannelCoroutine12l2gxei4u780 as ChannelCoroutine } from './ChannelCoroutine.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from '../CoroutineExceptionHandler.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Key_instancebefxze3q9f64 as Key_instance } from '../Job.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../CancellableContinuationImpl.mjs';
import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function produce(_this__u8e3s4, context, capacity, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? 0 : capacity;
  return produce_0(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
}
function produce_0(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  onCompletion = onCompletion === VOID ? null : onCompletion;
  var channel = Channel(capacity, onBufferOverflow);
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = new (ProducerCoroutine())(newContext, channel);
  if (!(onCompletion == null)) {
    coroutine.ex(onCompletion);
  }
  coroutine.pw(start, coroutine, block);
  return coroutine;
}
var ProducerCoroutineClass;
function ProducerCoroutine() {
  if (ProducerCoroutineClass === VOID) {
    class $ extends ChannelCoroutine() {
      constructor(parentContext, channel) {
        super(parentContext, channel, true, true);
      }
      cw() {
        return super.cw();
      }
      v1c(value) {
        this.c1c_1.n1b();
      }
      dw(value) {
        return this.v1c(value instanceof Unit() ? value : THROW_CCE());
      }
      ew(cause, handled) {
        var processed = this.c1c_1.l1b(cause);
        if (!processed && !handled) {
          handleCoroutineException(this.aw_1, cause);
        }
      }
      p1b(cause, $super) {
        return this.mx(cause, ($super == null ? true : $super instanceof ProducerCoroutine()) ? $super : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ProducerCoroutine', VOID, VOID, [SendChannel()], [1, 0]);
    ProducerCoroutineClass = $;
  }
  return ProducerCoroutineClass;
}
function *awaitClose(_this__u8e3s4, block, $completion) {
  var tmp;
  if (block === VOID) {
    tmp = awaitClose$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.js.getCoroutineContext' call
  // Inline function 'kotlin.check' call
  if (!($completion.pc().bd(Key_instance) === _this__u8e3s4)) {
    var message = 'awaitClose() can only be invoked from the producer context';
    throw IllegalStateException().o(toString(message));
  }
  try {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    (yield () => {
      var uCont = $completion;
      var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
      cancellable.z10();
      var cont = cancellable;
      _this__u8e3s4.q1b((it) => {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = cont;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$8 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.rc(tmp$ret$8);
        return Unit_instance;
      });
      return cancellable.jy();
    });
  }finally {
    block();
  }
  return Unit_instance;
}
function awaitClose$lambda() {
  return Unit_instance;
}
//region block: exports
export {
  awaitClose as awaitClose2xaex743rz43v,
  produce_0 as produce3s4oh9balbl5b,
  produce as produce1iljho2c8bp6o,
};
//endregion

//# sourceMappingURL=Produce.mjs.map
